import { useContext, useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged, User as FirebaseUser, signOut as firebaseSignOut } from 'firebase/auth';
import GlobalContext from './GlobalContext';

const useAuth = () => {

  const { setUser, token, setToken, setInitiative, setInitiatives } = useContext(GlobalContext);

  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const firebaseAuth = getAuth();
  let isLoadingToken = false;

  useEffect(() => {

    if (isLoadingToken) return;
    isLoadingToken = true;    

    if (firebaseAuth) {
      
      const unsubscribe = onAuthStateChanged(firebaseAuth, async (currentUser: FirebaseUser | null) => {
        setIsLoading(true);
        if (currentUser && !token) {
    
          const token = await currentUser.getIdToken();
          (window as any).accessToken = token;
          setToken(token);
          setIsAuthenticated(true);
          window.dispatchEvent(new Event('uerAuhenticated'));
        } 
        setIsLoading(false);
      });

      isLoadingToken = false;    
      return () => unsubscribe();
    }
  }, [firebaseAuth]);

  const logout = async () => {

    if (firebaseAuth) {

      try {
        await firebaseSignOut(firebaseAuth);
        setToken(null);
        setUser(null);
        setIsAuthenticated(false);
        setInitiative(undefined);
        setInitiatives(null);
        (window as any).location = "/";
      } catch (error) {
        console.error('Logout failed:', error);
      }
    }
  };
  
  return { isLoading, isAuthenticated, token, logout };
};

export default useAuth;